import { render } from "./SidebarItem.vue?vue&type=template&id=dc0ab174&scoped=true&ts=true"
import script from "./SidebarItem.vue?vue&type=script&lang=ts"
export * from "./SidebarItem.vue?vue&type=script&lang=ts"

import "./SidebarItem.vue?vue&type=style&index=0&id=dc0ab174&lang=scss&scoped=true"
import "./SidebarItem.vue?vue&type=style&index=1&id=dc0ab174&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc0ab174"]])

export default __exports__